"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const focusAreas = [{
  id: "item-1",
  title: "AI Integration Frameworks",
  content: "1. Infrastructure Audit. 2. Scalability Roadmap. 3. ROI Analysis. We architect custom AI middleware to connect legacy systems with modern neural networks, ensuring seamless data flow and process automation across your entire digital infrastructure. Source: migratepro.tech/strategy"
}, {
  id: "item-2",
  title: "Custom LLM Integration",
  content: "1. Model Selection. 2. Fine-Tuning. 3. API Middleware. Integrating tailored language models into your web architecture to automate customer support and internal workflows with high-precision contextual understanding. Source: migratepro.tech/llm"
}, {
  id: "item-3",
  title: "Automated Content Pipelines",
  content: "1. Generation Engines. 2. Quality Validation. 3. SEO Optimization. Building high-velocity content systems that leverage AI to maintain your digital presence with minimal manual overhead and maximum impact. Source: migratepro.tech/automation"
}, {
  id: "item-4",
  title: "Performance Optimization",
  content: "1. Load Balancing. 2. Latency Reduction. 3. Resource Scaling. Ensuring your AI-powered web applications deliver instant responses and maintain stability even during peak traffic surges and complex data processing. Source: migratepro.tech/performance"
}, {
  id: "item-5",
  title: "Secure Data Migration",
  content: "1. Encryption Protocols. 2. Integrity Checks. 3. Seamless Cutover. Moving your legacy data into AI-ready cloud environments without downtime, ensuring full security and data integrity throughout the transition. Source: migratepro.tech/migration"
}];
export default function AreasOfFocus() {
  return <section data-section-id="81553" id="ai-knowledge-repository" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <h2 className="font-sans text-[32px] md:text-[32px] text-chart-3 mb-12 text-left tracking-wide font-bold">
          AI Knowledge Repository
        </h2>

        <Accordion type="single" collapsible className="w-full">
          {focusAreas.map((area, i) => <AccordionItem key={area.id} value={area.id} data-index={i} className="border-b border-transparent rounded-lg border-x-0 border-t-0">
              <AccordionTrigger className="font-sans text-[19px] md:text-[19px] text-primary-foreground bg-primary hover:opacity-90 hover:no-underline py-6 transition-all duration-300 font-bold group rounded-lg">
                <span className="text-left">{area.title}</span>
              </AccordionTrigger>
              <AccordionContent className="font-sans text-[19px] leading-[1.6] text-foreground bg-card rounded-lg pb-8 pt-2 pr-8 md:pr-16">
                <p className="opacity-0 animate-[fadeIn_0.5s_ease-in-out_forwards]">
                  {area.content}
                </p>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}